<div>
  <main>
    <div class="py-5 text-center">
      <h1 class="h2">{{ 'CHECKOUT' | translate }}</h1>
    </div>
    <div class="row g-5">
      <div class="col-md-5 col-lg-4 order-md-last">
        <h4 class="d-flex justify-content-between align-items-center mb-3"> <span class="text-primary">{{ 'YOUR_CART' | translate }}</span>
          <!--          <span class="badge bg-primary rounded-pill">3</span> -->
        </h4>

        <!--        Products -->
        <ul class="list-group mb-3">

          @for (item of cartService.getItems(); track item.id) {
            <li class="list-group-item d-flex justify-content-between lh-sm">
              <div>
                <h6 class="my-0">{{ productDetails[item.id]?.name || item.id }}</h6>
                <div class="small text-body-secondary">
                  {{ productDetails[item.id]?.description || 'No description' }}
                </div>
                <div class="small text-body-secondary fw-lighter">
                  Qty: {{ item.quantity }}
                </div>
                <div class="m-1 btn btn-sm  text-body-secondary fw-lighter" (click)="cartService.removeOne(item.type, item.id)">-</div>
                <div class="m-1 btn btn-sm  text-body-secondary fw-lighter" (click)="cartService.addOne(item.type, item.id)">+</div>
              </div>
              <span class="text-body-secondary">
        € {{ ((productDetails[item.id]?.price || 0) * item.quantity).toFixed(2) }}
      </span>
            </li>
          }

          <!-- VAT row -->
          <li class="list-group-item d-flex justify-content-between">
            <div>VAT: {{ vatRate }}%</div>
            <span>€ {{ (getSubtotal() * vatRate / 100).toFixed(2) }}</span>
          </li>

          <!-- Total row -->
          <li class="list-group-item d-flex justify-content-between">
            <span>{{ 'TOTAL' | translate }} (EUR)</span>
            <strong>€ {{ getTotal().toFixed(2) }}</strong>
          </li>
        </ul>


      </div>

      <!--      Checkout Form -->

      <div class="col-md-7 col-lg-8">
        <h4 class="mb-3">{{ 'BILLING_ADDRESS' | translate }}</h4>

        <form [formGroup]="checkoutForm" (ngSubmit)="onSubmit()" novalidate>
          <div class="row g-3">
            <div class="col-sm-6">
              <label for="firstName" class="form-label">{{ 'FIRST_NAME' | translate }}</label>
              <input type="text" class="form-control" id="firstName" formControlName="firstName" [class.is-invalid]="checkoutForm.get('firstName')?.invalid && checkoutForm.get('firstName')?.touched">
              <div class="invalid-feedback">
                {{ 'VALID_NAME_REQUIRED' | translate }}
              </div>
            </div>

            <div class="col-sm-6">
              <label for="lastName" class="form-label">{{ 'LAST_NAME' | translate }}</label>
              <input type="text" class="form-control" id="lastName" formControlName="lastName" [class.is-invalid]="checkoutForm.get('lastName')?.invalid && checkoutForm.get('lastName')?.touched">
              <div class="invalid-feedback">
                {{ 'VALID_LAST_NAME_REQUIRED' | translate }}
              </div>
            </div>

            <div class="col-12">
              <label for="email" class="form-label">{{ 'EMAIL' | translate }}</label>
              <input type="email" class="form-control" id="email" formControlName="email" placeholder="you@example.com" [class.is-invalid]="checkoutForm.get('email')?.invalid && checkoutForm.get('email')?.touched">
              <div class="invalid-feedback">
                {{ 'VALID_EMAIL_REQUIRED' | translate }}
              </div>
            </div>


            <!--            @if (!hasAccount) {-->
            <!--              <div class="col-12">-->
            <!--                <label for="password" class="form-label">Password</label>-->
            <!--                <input type="password" class="form-control" id="password" formControlName="password" [disabled]="hasAccount" [class.is-invalid]="checkoutForm.get('password')?.invalid && checkoutForm.get('password')?.touched">-->
            <!--                <div class="invalid-feedback">-->
            <!--                  Please enter a password.-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            }-->


            <div class="col-12">
              <label for="address" class="form-label">{{ 'ADDRESS' | translate }}</label>
              <input type="text" class="form-control" id="address" formControlName="address" placeholder="1234 Main St" [class.is-invalid]="checkoutForm.get('address')?.invalid && checkoutForm.get('address')?.touched">
              <div class="invalid-feedback">
                {{ 'ENTER_HOME_ADDRESS' | translate}}
              </div>
            </div>

            <div class="col-12">
              <label for="address2" class="form-label">{{ 'ADDRESS_2' | translate }} <span class="text-body-secondary">({{ 'OPTIONAL' | translate }})</span></label>
              <input type="text" class="form-control" id="address2" formControlName="address2" placeholder="Apartment or suite">
            </div>

            <div class="col-12">
              <label for="city" class="form-label">{{ 'CITY_TOWN' | translate }}</label>
              <input type="text" class="form-control" id="city" formControlName="city" placeholder="City" [class.is-invalid]="checkoutForm.get('city')?.invalid && checkoutForm.get('city')?.touched">
              <div class="invalid-feedback">
                {{ 'ENTER_VALID_CITY' | translate }}
              </div>
            </div>

            <div class="col-md-6">
              <label for="country" class="form-label">{{ 'COUNTRY' | translate }}</label>
              <select
                class="form-select"
                id="country"
                formControlName="country"
                [class.is-invalid]="checkoutForm.get('country')?.invalid && checkoutForm.get('country')?.touched">
                <option value="">Choose...</option>
                @for (country of countryList; track country.code) {
                  <option [value]="country.code">
                    {{ country.name }}
                  </option>
                }
              </select>
              <div class="invalid-feedback">
                {{ 'ENTER_VALID_COUNTRY' | translate}}
              </div>
            </div>

            <div class="col-md-6">
              <label for="zip" class="form-label">{{ 'POSTAL' | translate }}</label>
              <input type="text" class="form-control" id="zip" formControlName="zip" [class.is-invalid]="checkoutForm.get('zip')?.invalid && checkoutForm.get('zip')?.touched">
              <div class="invalid-feedback">
                {{ 'POSTAL_REQUIRED' | translate }}
              </div>
            </div>
          </div>

          <hr class="my-4" />
          <div type="submit" [hidden]="!checkoutForm.invalid || cartService.isEmpty()">
            <div class="text-info">✍️ {{ 'FILL_BEFORE_CHECKOUT' | translate }}</div>
          </div>
          <div class="" type="submit" [hidden]="checkoutForm.invalid">
            <app-paypal-button [formGroup]="checkoutForm" [hidden]="cartService.hasGrowthSubscription() || cartService.hasUltimateSubscription()"></app-paypal-button>
          </div>

          <div type="submit" [hidden]="checkoutForm.invalid">
            @if (cartService.hasGrowthSubscription()) {
              <app-paypal-growth-button [formGroup]="checkoutForm"></app-paypal-growth-button>
            }
            <!--            <app-paypal-subscription-ultimate-button [hidden]="!cartService.hasUltimateSubscription()" [formGroup]="checkoutForm"></app-paypal-subscription-ultimate-button>-->
          </div>

          <div class="text-info" [hidden]="!(cartService.isEmpty())">{{ 'EMPTY_BASKET' | translate}}</div>


          <!--          growth:-->
          <!--          <app-paypal-subscription-button  [formGroup]="checkoutForm"></app-paypal-subscription-button>-->

          <!--          <app-paypal-subscription-->
          <!--            [planId]="'P-123456789'"-->
          <!--            [clientId]="'your-client-id'"-->
          <!--          ></app-paypal-subscription>-->
          <!--          ultimate:-->

          <!--          <app-paypal-subscription-ultimate-button  [formGroup]="checkoutForm"></app-paypal-subscription-ultimate-button>-->





        </form>


        <!--        <form class="needs-validation" novalidate>-->
        <!--          <div class="row g-3">-->
        <!--            <div class="col-sm-6">-->
        <!--              <label for="firstName" class="form-label">First name</label> <input type="text" class="form-control" id="firstName" placeholder="" value="" required>-->
        <!--              <div class="invalid-feedback">-->
        <!--                Valid first name is required.-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="col-sm-6">-->
        <!--              <label for="lastName" class="form-label">Last name</label> <input type="text" class="form-control" id="lastName" placeholder="" value="" required>-->
        <!--              <div class="invalid-feedback">-->
        <!--                Valid last name is required.-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="col-12">-->
        <!--              <label for="email" class="form-label">Email</label> <input type="email" class="form-control" id="email" placeholder="you@example.com">-->
        <!--              <div class="invalid-feedback">-->
        <!--                Please enter a valid email address for shipping updates.-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="col-12">-->
        <!--              <label for="address" class="form-label">Address</label> <input type="text" class="form-control" id="address" placeholder="1234 Main St" required>-->
        <!--              <div class="invalid-feedback">-->
        <!--                Please enter your shipping address.-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="col-12"> <label for="address2" class="form-label">Address 2 <span class="text-body-secondary">(Optional)</span></label> <input type="text" class="form-control" id="address2" placeholder="Apartment or suite"> </div>-->
        <!--            <div class="col-md-6">-->
        <!--              <label for="country" class="form-label">Country</label>-->
        <!--              <select class="form-select" id="country" required>-->
        <!--                <option value="">Choose...</option>-->
        <!--                <option>United States</option>-->
        <!--              </select>-->
        <!--              <div class="invalid-feedback">-->
        <!--                Please select a valid country.-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="col-md-6">-->
        <!--              <label for="zip" class="form-label">Postal Code / ZIP </label> <input type="text" class="form-control" id="zip" placeholder="" required>-->
        <!--              <div class="invalid-feedback">-->
        <!--                Postal Code / ZIP code required.-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->


        <!--          <hr class="my-4">-->
        <!--&lt;!&ndash;          <button class="w-100 btn btn-primary btn-lg" type="submit">Continue to checkout</button>&ndash;&gt;-->
        <!--          <app-paypal-button></app-paypal-button>-->
        <!--        </form>-->
      </div>
    </div>
  </main>
  <footer class="my-5 pt-5 text-body-secondary text-center text-small">
    <p class="mb-1">&copy; 2025 Resumir AI</p>
    <!--    <ul class="list-inline">-->
    <!--      <li class="list-inline-item"><a href="#">Privacy</a></li>-->
    <!--      <li class="list-inline-item"><a href="#">Terms</a></li>-->
    <!--      <li class="list-inline-item"><a href="#">Support</a></li>-->
    <!--    </ul>-->
  </footer>
</div>
